module.exports = __webpack_public_path__ + "img/shield-zap.d806ffcf.svg";